import {ChangeDetectionStrategy, Component, input, output} from '@angular/core';
import {LicencePlanSummary} from '../../../../../api';
import {TableModule} from 'primeng/table';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'elcia-licence-plan-grid',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TableModule, TranslatePipe],
  templateUrl: './licence-plan-grid.html',
})
export class LicencePlanGrid {
  licencePlans = input.required<LicencePlanSummary[]>();
  licencePlanSelected = output<LicencePlanSummary>();

  onRowSelect(plan: LicencePlanSummary): void {
    this.licencePlanSelected.emit(plan);
  }
}
